import React, { useState, useMemo } from "react";
import NewsCard from "../components/NewsCard";
import useNews from "../useNews";

export default function News() {
  const { list: news, loading } = useNews();
  const [cat, setCat] = useState("All");

  const cats = useMemo(
    () => ["All", ...Array.from(new Set(news.map((n) => n.category).filter(Boolean)))],
    [news]
  );

  const list = useMemo(
    () => (cat === "All" ? news : news.filter((n) => n.category === cat)),
    [cat, news]
  );
  const featured = list[0];
  const rest = list.slice(1);

  return (
    <div data-testid="news-page" className="relative">
      <span className="stamp-num absolute top-6 right-6 md:right-12">N° 05</span>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-12 md:pt-16 pb-14">
        <p className="section-num">
          <strong>05</strong> News & journal
        </p>
        <div className="grid md:grid-cols-12 gap-10 items-end mt-5">
          <h1 className="md:col-span-8 font-display text-display-lg text-ink tracking-tightest fade-up">
            Notes from the
            <br />
            <span className="font-italic text-coral">growing room.</span>
          </h1>
          <p className="md:col-span-4 text-ink/60 max-w-md text-[15px] leading-relaxed fade-up-d1">
            Workshop updates, recipes, behind-the-scenes from the unit, and
            occasional thoughts on running a small family-run mushroom farm.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-2.5" data-testid="news-filters">
          {cats.map((c) => {
            const active = c === cat;
            return (
              <button
                key={c}
                data-testid={`news-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setCat(c)}
                className={`rounded-full px-5 py-2.5 text-sm font-medium border transition-all ${
                  active
                    ? "bg-ink text-bone border-ink"
                    : "bg-bone text-ink border-ink/15 hover:border-coral hover:text-coral"
                }`}
              >
                {c}
                <span className={`ml-2 text-[11px] tabular-nums ${active ? "text-bone/60" : "text-muted"}`}>
                  {c === "All" ? news.length : news.filter((n) => n.category === c).length}
                </span>
              </button>
            );
          })}
        </div>
      </section>

      {loading && (
        <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20 text-center text-muted">
          Loading stories…
        </section>
      )}

      {!loading && featured && (
        <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20">
          <NewsCard item={featured} variant="featured" />
        </section>
      )}

      {!loading && rest.length > 0 && (
        <section className="max-w-7xl mx-auto px-6 md:px-12 pb-32">
          <div className="spore-divider text-ink mb-16" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-x-10 md:gap-y-16">
            {rest.map((n) => (
              <NewsCard key={n.slug} item={n} />
            ))}
          </div>
        </section>
      )}

      {!loading && list.length === 0 && (
        <section className="max-w-3xl mx-auto px-6 py-24 text-center text-muted">
          <p>No stories in this category yet.</p>
        </section>
      )}
    </div>
  );
}
